import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const yang = require("@/images/yang.png");

const wastePaperDialog = [
  new Dialog(
    "SONNY YANG: Nothing in here but discarded drafts of co-worker erotic fiction",
    yang,
    require("@/audio/Pandemic-117-Sonny-Revised-MP3.mp3")
  ),
];

const databaseDialog = [
  new Dialog(
    "SONNY YANG: Well well... Dareth Schamren’s employee profile. Let’s see how he enjoys having to head in to the office during a global health crisis…",
    yang,
    require("@/audio/Pandemic-118-Sonny-2-Revised-MP3.mp3")
  ),
  new Dialog(
    "[Changed Dareth’s Job Position from ‘General Manager’ to ‘Essential Worker’]",
    require("@/images/Shibari_Computer_HR_Database.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "[MEANWHILE.... AT DARETH SHAMREN'S HOUSE...]",
    require("@/images/Vincent_Dareths_House.png"),
    require("@/audio/flipoff.mp3")
  ),
  new Dialog(
    "DARETH: Hang on brother, I’ve got another call coming through… Dareth Schamren speaking.",
    require("@/images/Dareth_with_Phone.png"),
    require("@/audio/Pandemic-118-Dareth-1-MP3.mp3")
  ),
  new Dialog(
    "SHIBARI HR REPRESENTATIVE: Hello Mr. Schamren, I’m calling from the Shibari International Headquarters in Geneva. Our employee records show that you have not clocked in to work in the last seven days.As you are listed as an ‘essential worker’ on our database, we strongly urge you to attend to your role at your local Shibari branch office as   soon as possible, otherwise we may be forced to terminate your employment",
    require("@/images/Dareth_with_Phone.png"),
    require("@/audio/Pandemic-118-Shibari-HR-Rep-MP3.mp3")
  ),
  new Dialog(
    "DARETH: Impossible! I’m not one of those lowly essential workers - there must be some mistake! Looks like I’ll have to go and sort this out myself.",
    require("@/images//Dareth_with_Phone.png"),
    require("@/audio/Pandemic-118-Dareth-2-MP3.mp3")
  ),
  new Dialog(
    "[DARETH SCHAMREN LEAVES THE HOUSE]",
    require("@/images/Vincent_Dareths_House.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

export class HumanResources extends Scene {
  title = "Human Resources Department";
  async init() {
    if (this.state.storylines.employeesFled) {
      this.description = "[THE OFFICE IS EMPTY]";
      this.image = require("@/images/HR_Manager_Office.png");
      this.audio = null;
    } else {
      this.description =
        "HR MANAGER: I understand these are uncertain and unprecedented times but that’s no reason to be dilly - dallying now! Let’s get back to work and be the best Shibari branch we can be!";
      this.image = require("@/images/HR_Manager.png");
      this.audio = require("@/audio/Pandemic-114-HR-Manager-Revised.mp3");
    }
  }
  get options(): any[] {
    const choices = [
      new Choice("Leave", async () => await this.navigate(scenes.OfficeInterior())),
    ];
    if (this.state.storylines.employeesFled) {
      return [
        new Choice("Search Employee Database", async () => {
          if (this.state.storylines.darethDemoted) {
            this.description =
              "SONNY YANG: I’ve already done what I came here to do.";
          } else {
            await this.dialogRunner(databaseDialog)
            this.state.storylines.darethDemoted = true;
            this.init();
          }
        }),
        new Choice("Search Waste Basket", async () => {
          await this.dialogRunner(wastePaperDialog)
          this.init()
        }),
        ...choices,
      ];
    } else {
      return choices;
    }
  }
}

export default new HumanResources();
